module.exports = __webpack_public_path__ + "static/img/4_1.75bff60f.jpg";